module.exports = __webpack_public_path__ + "img/YiningZhao.1fe65407.jpg";